import { TimerContextType } from '../types/timer';

export function handleUrlAction(url: URL, timer: TimerContextType) {
  const action = url.searchParams.get('action');
  
  switch (action) {
    case 'start-focus':
      if (timer.state.stage !== 'focus') {
        timer.skipStage();
      }
      timer.startTimer();
      break;
      
    case 'start-break':
      if (timer.state.stage === 'focus') {
        timer.skipStage();
      }
      timer.startTimer();
      break;
      
    default:
      // No action needed
      break;
  }
}

export function setupUrlActionHandler(timer: TimerContextType) {
  // Handle initial URL
  const url = new URL(window.location.href);
  handleUrlAction(url, timer);
  
  // Clear the action from URL to prevent re-triggering
  if (url.searchParams.has('action')) {
    url.searchParams.delete('action');
    window.history.replaceState({}, '', url.toString());
  }
} 